import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { SITE } from "@/data/site";

export default function PrivacyPolicy() {
  return (
    <>
      <Seo title="Privacy Policy" description="How Kensmarc Electric collects and uses the information you submit through this website." path="/privacy-policy" />
      <PageHeader eyebrow="Legal" title="Privacy Policy" />
      <section className="section-pad">
        <div className="container-kx max-w-3xl space-y-6 text-neutral-300">
          <p className="text-sm text-neutral-500">Last updated: {new Date().getFullYear()}</p>
          <div>
            <h2 className="font-display text-xl font-bold uppercase text-white">Information we collect</h2>
            <p className="mt-2 leading-relaxed text-neutral-400">
              When you submit a quote request or review through this website, we collect the information you
              provide — such as your name, phone number, email, service address, project details, and any
              photos you choose to upload.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold uppercase text-white">How we use it</h2>
            <p className="mt-2 leading-relaxed text-neutral-400">
              We use your information solely to respond to your request, prepare a quote, and communicate with
              you about your project. We do not sell your information.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold uppercase text-white">Contact</h2>
            <p className="mt-2 leading-relaxed text-neutral-400">
              Questions about your information? Contact Kensmarc Electric at{" "}
              <a href={SITE.emailHref} className="font-semibold text-amber-400 hover:underline">{SITE.email}</a> or{" "}
              <a href={SITE.phonePrimary.tel} className="font-semibold text-amber-400 hover:underline">{SITE.phonePrimary.display}</a>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
